import React from 'react';

const defaultContext = {
    currentStepIndex: 0,
    currentStepId: '',
    isNextLoading: false,
    isNavigateLoading: false,
    isNextDisabled: false,
    isBackEnabled: false,
    steps: [],
    navigateByIndex: Function.prototype,
    navigateById: Function.prototype,
    enableNext: Function.prototype,
    disableNext: Function.prototype,
    enableBack: Function.prototype,
    disableBack: Function.prototype,
    next: Function.prototype,
    back: Function.prototype,
    setSteps: Function.prototype
};

const StepperContext = React.createContext(defaultContext);

export default StepperContext;
